import logo from "./iOctaneLogo.png";
import loginBg from "./login_bg.png";
import acitivityNoitifcation from "./activity_notification.png";
import activityRemainder from "./activity_remainder.png";
import studentPositionVector from "./position_vector.png";
// import dashboardPageIcon from "./dashboard_page_icon.png";
import profilePageIcon from "./profile_page_icon.png";
import studentProfile from "./student_profile.jpg";
import childImg from "./child_img.jpg";
import liveChatIcon from "./live_chat_icon.png";
import studentListPageIcon from "./student_page_icon.png";
import academicTrainingIcon from "./academic_training_icon.png";
import teacherAssignImage from "./teacher_assign_image.png";
import gradePageIcon from "./grade_page_icon.png";
import notepadIcon from "./notepad_icon.png";
import sliderThumbnail from "./slider_image.jpg";
import downloadableContentIcon from "./downloadable_content_icon.png";
import recordedLecturesIcon from "./recorded_lectures_icon.png";
import additionalServicesPageIcon from "./aditional_services_icon.png";
import downloadableContentBg from "./downloadable_content_bg.png";
import recordedLectureBg from "./recorded_lectures_bg.png";
import activityReminderIcon from "./activity_reminder_icon.png";
import recordedLectureImg from "./recorded_lecture_img.png";
import teacherPageIcon from "./teacher_page_icon.png";
import contentPageIcon from "./content_page_icon.png";
import bortherlyLiveChatIcon from "./brotherly_live_chat_icon.png";
import studentTeacherProfile from "./student_teacher_profile.png";
import adminPageIcon from "./admin_page_icon.png";
import performancePageIcon from "./performance_page_icon.png";
import monteroSalesPageIcon from "./monterrosales_page_icon.png";
import reportPageIcon from "./reports_page_icon.png";
import studentCommunityProfile from "./student_community_profile.png";
import marketingPageIcon from "./marketing_page_icon.png";
import marketingNeedsLeads from "./marketing_needs_leads.png";
import marketingWithdrawalsReturns from "./marketing_withdrawals_returns.png";
import learningCenterPageIcon from "./learning_center_page_icon.png";
import learningCenterChatIcon from "./learning_center_chat_icon.png";
import dummyCompanyLogo from "./dummy_company_logo.png";
import dragAndDropIcon from "./drag_and_drop_icon.png";
import consellingReqImg from "./conselling_req_img.png";
import volunteersicon from "./volunteers_page_icon.png";
import poli from "./poli.png";
import unimenitos from "./unimenitos.png";
import areandina from "./areandina.png";
import StudentProfile from "./Student-Profile.png";
import genogramaImg from "./genograma_img.png";
import iconCommunity from "./Icon_Community.png";
import socialIconTeachers from "./social_Icon_Teachers.png";
import LoginPagePod from "./loginPod.png";
import MicrosoftLogo from "./microsoft-logo.png";
import XPod from "./xpod.png";
import MPod from "./mpod.png";
import MeetingPodImage from "./meetingpod-view.png";
import FreepikMessage from "./freepik-message.png";
import TableIcon from "./table-icon.png";
import Logo from "./reia_logo.png";
import HelpIcon from "./help-icon.png";
import Logout from "./log-out.png";
import ValuationDcf from "./valuation-dcf.png";
import RentRoll from "./rent-roll.png";
import ValuationSetting from "./valuation-setting.png";
import CashFlows from "./cash-flows.png";
import DashboardIcon from "./dashboard-icon.png";
import ProjectIcon from "./project-icon.png";
import SettingIcon from "./setting-icon.png";
import DrawerImg from "./drawer-icon.png";
import DrawerIcon from "./drawer-logo.png";
import PortfolioIcon from "./portfolio-icons.png";
import AssetsIcon from "./assets-icons.png";
import AssetsImage from "./asset-icon.png";
import NoUserFound from "./nouser.png";
import kid from "./kid.png";
import ReprotIcon from "./reports-icon.png";
import UserManegementIcon from "./user-management-icon.png";
import ActivityLogIcon from "./activity-log-icons.png";
import ParametersIcon from "./parameters-icons.png";
import Dstatis from "./DSTATIS.png";
import anchor from "./anchor.png";
import area from "./area.png";
import building from "./building.png";
import ownership from "./ownership.png";
import sitearea from "./sitearea.png";
import srewdriver from "./srewdriver.png";
import stopwatch from "./stopwatch.png";
import vacancyrate from "./vacancyrate.png";
import assetDashboardIcon from "./asset-dashboard.png";
import assetCalculationIcon from "./asset-calculation.png";
import assetIncomeCostIcon from "./asset-income-cost.png";
import assetRentRollIcon from "./asset-rent-roll.png";
import assetCashFlowIcon from "./asset-cash-flow.png";
import assetCalculationSettingIcon from "./asset-calculation-setting.png";
import archiveIcon from "./archive-icon.png";
import greenBuilding from "./green building.png";
import wallet from "./wallet.png";
import assets from "./assets.png";
import housecheck from "./housecheck.png";
import redHouse from "./redHouse.png";
import flyTower from "./flyTower.png";
import menAvatar from "./menAvatar.png";
import blueSky from "./blueSky.png";
import dashboard from "./dashboard.svg";
import calculation from "./calculation.svg";
import roll from "./roll.svg";
import price from "./price.svg";
import detail from "./detail.svg";
import danger from "./danger.svg";
import pound from "./pound.svg";
import ImportIcon from "./import_icon";
import SaveIcon from "./save_icon";
import addRowDown from './add_row_down_icon.svg'
import addRowUp from './add_row_up_icon.svg'
import copy from './copy_icon.svg'

const IMAGES = {
  ADD_ROW_DOWN: addRowDown,
  COPY: copy,
  ADD_ROW_UP: addRowUp,
  MEN_AVATAR: menAvatar,
  RED_HOUSE: redHouse,
  FLY_TOWER: flyTower,
  BLUE_SKY: blueSky,
  GREEN_Building: greenBuilding,
  HOUSE_CHECK: housecheck,
  ASSETS: assets,
  WALLET: wallet,
  ANCHOR: anchor,
  AREA: area,
  BUILDING: building,
  OWNER_SHIP: ownership,
  SITE_AREA: sitearea,
  SCREW: srewdriver,
  WATCH: stopwatch,
  VACANCY_RATE: vacancyrate,
  IOCTANE_LOGO: logo,
  LOGIN_BG: loginBg,
  ACTIVITY_NOTIFICIATION: acitivityNoitifcation,
  ACTIVITY_REMAINDER: activityRemainder,
  STUDENT_POSITION_VECTOR: studentPositionVector,
  // DASHBOARD_ICON: dashboardPageIcon,
  PROFILE_ICON: profilePageIcon,
  STUDENT_PROFILE: studentProfile,
  CHILD_IMG: childImg,
  LIVE_CHAT_ICON: liveChatIcon,
  STUDENT_LIST_PAGE_ICON: studentListPageIcon,
  ACADEMIC_TRAINING_PAGE_ICON: academicTrainingIcon,
  TEACHER_ASSIGN_IMAGE: teacherAssignImage,
  GRADE_PAGE_ICON: gradePageIcon,
  NOTEPAD_ICON: notepadIcon,
  SLIDER_THUMBNAIL: sliderThumbnail,
  DOWNLOADABLE_CONTENT_ICON: downloadableContentIcon,
  RECORDED_LECTURES_ICON: recordedLecturesIcon,
  ADDITONAL_SERVICES_PAGE_ICON: additionalServicesPageIcon,
  DOWNLOADABLE_CONTENT_BG: downloadableContentBg,
  RECORDED_LECTURES_BG: recordedLectureBg,
  ACTIVITY_REMAINDER_ICON: activityReminderIcon,
  RECORDED_LECTURE_IMG: recordedLectureImg,
  TEACHER_PAGE_ICON: teacherPageIcon,
  CONTENT_PAGE_ICON: contentPageIcon,
  BROTHERLY_LIVE_CHAT_ICON: bortherlyLiveChatIcon,
  STUDENT_TEACHER_PROFILE: studentTeacherProfile,
  ADMIN_PAGE_ICON: adminPageIcon,
  PERFORMANCE_PAGE_ICON: performancePageIcon,
  MONTERO_SALES_PAGE_ICON: monteroSalesPageIcon,
  REPORTS_PAGE_ICON: reportPageIcon,
  STUDENT_COMMUNITY_PROFILE: studentCommunityProfile,
  MARKETING_PAGE_ICON: marketingPageIcon,
  MARKETING_NEEDS_LEADS: marketingNeedsLeads,
  MARKETING_WITHDRAWALS_RETURNS: marketingWithdrawalsReturns,
  LEARNING_CENTER_PAGE_ICON: learningCenterPageIcon,
  LEARNING_CENTER_CHAT_ICON: learningCenterChatIcon,
  DUMMY_COMPANY_LOGO: dummyCompanyLogo,
  DRAG_AND_DROP_ICON: dragAndDropIcon,
  CONSELLING_REQ_IMG: consellingReqImg,
  VOLUNTEER_PAGE_ICON: volunteersicon,
  POLO: poli,
  UNIMENITO: unimenitos,
  AREANIDIA: areandina,
  STUDENTPROFILE: StudentProfile,
  GENOGRAMA_IMG: genogramaImg,
  ICON_COMMUNITY: iconCommunity,
  TEACHER_ICON_SOCIAL: socialIconTeachers,
  LOGIN_PAGE_POD: LoginPagePod,
  MICROSOFT_LOGO: MicrosoftLogo,
  XPOD: XPod,
  MPOD: MPod,
  MEETING_POD_VIEW: MeetingPodImage,
  FREE_PIK_MESSAGE: FreepikMessage,
  TABLE_ICON: TableIcon,
  VALUATION_DCF: ValuationDcf,
  RENT_ROLL: RentRoll,
  VALUATION_SETTING: ValuationSetting,
  CASH_FLOWS: CashFlows,
  LOGO: Logo,
  LOGOUT: Logout,
  HELP_ICON: HelpIcon,
  DASHBOARD_ICON: DashboardIcon,
  PROJECT_ICON: ProjectIcon,
  SETTING_ICON: SettingIcon,
  DRAWER_ICON_WHITE: DrawerIcon,
  DRAWER_ICON: DrawerImg,
  PORTFOLIO_ICON: PortfolioIcon,
  ASSETS_ICON: AssetsIcon,
  ASSETS_IMAGE: AssetsImage,
  REPORT_ICON: ReprotIcon,
  USER_MANAGEMENT_ICON: UserManegementIcon,
  ACTIVITY_LOG_ICON: ActivityLogIcon,
  PARAMETER_ICON: ParametersIcon,
  NO_USER: NoUserFound,
  KID: kid,
  DSTATIS: Dstatis,
  ASSET_DASHBOARD_ICON: assetDashboardIcon,
  ASSET_CALCULATION_ICON: assetCalculationIcon,
  ASSET_INCOME_COST_ICON: assetIncomeCostIcon,
  ASSET_RENT_ROLL_ICON: assetRentRollIcon,
  ASSET_CASH_FLOW_ICON: assetCashFlowIcon,
  ASSET_CALCULATION_SETTING_ICON: assetCalculationSettingIcon,
  ARCHIVE_ICON: archiveIcon,
  DASHBOARD: dashboard,
  CALCULATION: calculation,
  ROLL: roll,
  PRICE: price,
  DETAIL: detail,
  DANGER: danger,
  POUND: pound,
  IMPORT_ICON: ImportIcon,
  SAVE_ICON: SaveIcon,
};
export default IMAGES;
